module.exports = __webpack_public_path__ + "static/media/logo.2225dc5c.png";